<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div class="page-view">
	<div class="selected-image-top-level">
		<preview-carousel
			[slides]="attachedFilesService.file$ | async"
			[selectedFile]="attachedFilesService.fileSelected$ | async"
			[selectFile]="attachedFilesService.selectFile.bind(attachedFilesService)"
			[width]="carouselSlideWidth"
			[height]="300"
		>
			<div class="sheet-container">
				<attached-file-viewer
					*ngFor="let file of attachedFilesService.file$ | async"
					class="tile-container"
					[file]="file"
					[showBorder]="false"
					(fileClicked)="attachedFilesService.launchFullViewClicked()"
					[size]="imageSize.Preview"
				>
				</attached-file-viewer>
			</div>
		</preview-carousel>
		<mat-form-field class="file-description" automationId="imageFileDescription">
			<mat-label>{{ Strings.TICKET_EDIT_CAPTION }}</mat-label>
			<textarea
				matInput
				automationId="imageFileDescriptionTextArea"
				class="file-description-text-area"
				[placeholder]=""
				type="text"
				clearable-input
				[formControl]="fileDescription"
				[errorStateMatcher]="errorStateMatcher"
				(blur)="saveFileDescription()"
			>
			</textarea>
			<mat-error *ngIf="fileDescription.invalid">{{ errorMessage }}</mat-error>
		</mat-form-field>
	</div>
	<div class="film-strip">
		<div class="image-square" *ngFor="let file of attachedFilesService.file$ | async">
			<attached-file-viewer
				[file]="file"
				[showBorder]="file.$id === (attachedFilesService.fileSelected$ | async)?.$id"
				(fileClicked)="selectImageToPreview(file)"
				[id]="file.$id"
			>
			</attached-file-viewer>
		</div>
	</div>
</div>
